import { useNavigate } from 'react-router-dom'
import { BuildingStorefrontIcon } from '@heroicons/react/24/outline'
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid'
import AuthPromptModal from '../common/AuthPromptModal'
import DisplayForUserType from '../auth/DisplayForUserType'
import USER_TYPE from '../../constants/userType'
import { useAuth } from '../../contexts/AuthContext'

export const GetStartedSection = () => {
  const navigate = useNavigate()
  const { userType } = useAuth()

  const getGetStartedText = () => {
    if (!userType)
      return (
        <p className="mb-4 text-foreground-secondary">
          Whether you're a retailer looking to expand your product range or a wholesaler aiming to
          reach more retailers, Sokooni is here to help you grow your business.
        </p>
      )

    if (userType === USER_TYPE.customer) {
      {
        return (
          <p className="mb-4 text-foreground-secondary">
            As a customer, you can explore a wide range of products from various retailers on
            Sokooni.
          </p>
        )
      }
    }
  }

  return (
    <section className="">
      <h2 className="font-inter font-extrabold text-lg text-black mb-4">Get Started here</h2>
      {getGetStartedText()}
      <div className=" gap-x-4 flex max-w-md">
        <DisplayForUserType userTypes={[USER_TYPE.guest]}>
          <button
            className="
            flex-1
            flex items-center justify-center gap-x-2 
            bg-gradient-to-r from-primary-900 to-primary-700
            text-white 
            font-medium font-inter text-base /* font-weight: 500 -> medium, font-size ~17px -> text-base? text-lg? */
            px-4 py-3 /* Adjust padding for ~60px height */
            rounded-md /* border-radius: 4.7px */
            hover:opacity-90 transition-opacity
          "
            style={{ lineHeight: '21px' }}
            onClick={() => navigate('/signup/retailer')}
          >
            <span>Sell on Sokooni</span>
            <BuildingStorefrontIcon className="h-7 w-7 flex-shrink-0" />
          </button>
        </DisplayForUserType>
        <AuthPromptModal>
          <button
            className="
                    flex items-center justify-center gap-x-2 flex-1 
                    bg-tertiary-600 /* Changed to solid blue */
                    text-white 
                    font-medium font-inter text-base 
                    px-4 py-3 
                    rounded-md 
                    hover:bg-tertiary-700 transition-colors /* Adjusted hover for solid */
                  "
            style={{ lineHeight: '21px' }}
            onClick={() => navigate('/product-finder')}
          >
            <div className="text-center">Find My Product</div>
            <MagnifyingGlassIcon className="h-7 w-7 flex-shrink-0" />
          </button>
        </AuthPromptModal>
      </div>
    </section>
  )
}
